import cssVars from 'css-vars-ponyfill'
import Navigation from './navigation'
import Global from './global'
// import GMap from './gmap'

export default {
  header: $('.js-header'),

  init() {
    Navigation.init()
    this.setCSSVars()
    this.scrollNext()
    this.formRequired()
    this.fileBtn()
    this.copyLink()
    this.portalLoginAjax()
    // GMap.init()
    this.setNewsletterContent()
    this.initLoginEmailValidation()

    this.onResize()

    const mainHeader = this.header
    const fixHeader = () => {
      if ($(window).scrollTop() > 0 && !mainHeader.hasClass('is-sticky')) {
        mainHeader.addClass('is-sticky')
      } else if (
        $(window).scrollTop() <= 0 &&
        mainHeader.hasClass('is-sticky')
      ) {
        mainHeader.removeClass('is-sticky')
      }
    }
    fixHeader()

    $(window).on('scroll', function () {
      fixHeader()
    })

    $(
      'a[href^="#"]:not([href="#"],[href^="#fancy-"],[href^="#collapse-"],[href^="#pane-"],[href^="#tabs-"],[role="tab"],[data-vc-accordion]), a[href^="/#"]'
    ).on('click', e => {
      let href = $(e.currentTarget).attr('href')
      if (href.startsWith('/#') && location.pathname === '/') {
        href = href.slice(1)
      }
      this.smoothScroll(href, e)
      this.smoothScroll($(e.currentTarget).attr('href'), e)
    })
    if (window.location.hash && $(window.location.hash).length) {
      this.smoothScroll(window.location.hash)
    }
  },
  onLoad() {},
  setCSSVars() {
    cssVars({
      variables: {
        '--body-width': document.body.clientWidth + 'px',
      },
    })
  },
  scrollNext() {
    const $scrollNextBtn = $('.js-scroll-next')

    if ($scrollNextBtn.length) {
      const mainHeader = this.header
      $scrollNextBtn.on('click', function () {
        const $section = $(this).closest('.js-scroll-next-wrapper')
        if ($section.length) {
          $('html, body').animate(
            {
              scrollTop:
                $section.offset().top +
                $section.outerHeight() -
                mainHeader.outerHeight(),
            },
            600
          )
        }
      })
    }
  },
  formRequired() {
    const $forms = $('.wpcf7')

    if ($forms.length) {
      const checkFormRequiered = $form => {
        const requiredFields = $form.find(
          'input[aria-required="true"], textarea[aria-required="true"], select[aria-required="true"]'
        )
        const submitBtn = $form.find('.wpcf7-submit')
        let disabled = false

        requiredFields.each(function () {
          if (!$(this).val()) {
            disabled = true
          }
        })

        if (disabled) {
          submitBtn.attr('disabled', true)
        } else {
          submitBtn.removeAttr('disabled')
        }
      }

      $forms.each(function () {
        const $this = $(this)
        const requiredFields = $this.find(
          'input[aria-required="true"], textarea[aria-required="true"], select[aria-required="true"]'
        )

        if (requiredFields.length) {
          $this.find('.wpcf7-submit').attr('disabled', true)
        }

        checkFormRequiered($this)

        requiredFields.on('change keyup', function () {
          checkFormRequiered($this)
        })
      })
    }
  },
  copyLink() {
    const saveButton = $('.js-save-button')
    const tooltipText = 'Link Saved!'

    saveButton.on('click', function () {
      const urlToCopy = window.location.href

      const $tempInput = $('<input>')
      $('body').append($tempInput)
      $tempInput.val(urlToCopy).select()

      try {
        document.execCommand('copy')

        saveButton.tooltip({
          title: tooltipText,
          placement: 'top',
          trigger: 'manual',
        })

        saveButton.tooltip('show')
        setTimeout(function () {
          saveButton.tooltip('hide')
        }, 2000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      } finally {
        $tempInput.remove()
      }
    })
  },
  fileBtn() {
    $('.wpcf7-file').on('change', function (event) {
      const selectedFile = event.target.files[0]
      const fileContainer = $('#file-container')

      if (selectedFile) {
        const fileNameContainer = $('<div class="file-name"></div>')
        const fileNameText = $('<span class="file-name__text"></span>').text(
          selectedFile.name
        )
        const deleteButton = $('<span class="delete-button"></span>').on(
          'click',
          function () {
            $('.wpcf7-file').val('')
            fileNameContainer.remove()
          }
        )

        fileNameText.appendTo(fileNameContainer)
        deleteButton.appendTo(fileNameContainer)
        fileContainer.html(fileNameContainer)
      } else {
        fileContainer.empty()
      }
    })
  },
  portalLoginAjax() {
    $('#username_login').on('submit', function (e) {
      e.preventDefault()
      const data = $(this).serializeArray()
      data.push({ name: 'action', value: 'username_login' })
      /* global ajaxObj */
      $.ajax({
        url: ajaxObj.ajaxUrl,
        type: 'POST',
        dataType: 'json',
        data: data,
        success: response => {
          if (response.success === false) {
            $('.error-message').show().text(response.data.message)
          } else {
            window.location.href = response.data.redirectPage
          }
        },
        error: (xhr, status, error) => {
          console.error(error)
        },
      })
    })
  },
  smoothScroll(link, e) {
    if (
      link &&
      link.indexOf('#') > 0 &&
      link.split('#')[0].indexOf(location.origin + location.pathname) !== 0
    ) {
      return false
    }
    if (e) e.preventDefault()
    let hash = false
    if (!link && window.location.hash) {
      hash = window.location.hash
    } else if (link && link.indexOf('#') >= 0) {
      hash = '#' + link.split('#')[1]
    } else if (
      link &&
      location.pathname.replace(/^\//, '') ==
        link.pathname.replace(/^\//, '') &&
      location.hostname == link.hostname
    ) {
      hash = link.hash
    }
    if (hash && $(hash).length) {
      if (Global.htmlFixedState) {
        Navigation.menuToggle()
      }
      $('html, body').animate(
        {
          scrollTop: $(hash).offset().top - this.header.outerHeight(),
        },
        600
      )
      history.replaceState(null, null, hash)
    }
    $(window).trigger('hashchange')
  },
  onResize() {
    $(window).resize(() => {
      this.setCSSVars()
    })
  },
  setNewsletterContent() {
    const iframe = document.querySelector('.js-newsletter-iframe')
    const embedDocOrigin = document.querySelector('.js-newsletter-content')

    if (!iframe || !embedDocOrigin) {
      return
    }

    const frame = iframe.contentWindow.document
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = embedDocOrigin.getAttribute('data-content')

    const $doc = $(tempDiv)

    // nl - Newsletter
    const $nlContent = $doc.find('#bodyTable')
    const $nlContentInner = $doc.find('.mceWrapperOuter table:first')
    const $nlContentParent = $nlContent.parent()
    const $nlTopBar = $doc.find('#awesomewrap')
    const $nlScripts = $doc.find('script')
    const $nlLinks = $doc.find('a')

    if ($nlLinks.length) {
      $nlLinks.attr('target', '_blank')
    }

    if ($nlTopBar.length) {
      $nlTopBar.remove()
    }

    if ($nlScripts.length) {
      $doc.find('script').remove()
    }

    if (
      $nlContent.length &&
      $nlContentInner.length &&
      $nlContentParent.length
    ) {
      $nlContentInner.css('max-width', '100%')

      $nlContent.replaceWith($nlContentInner)
    }

    // Add custom styles
    const style =
      '<style>' +
      'html{border: none !important;}' +
      'html::-webkit-scrollbar{width: 4px;}' +
      'html::-webkit-scrollbar-track{background-color: transparent;}' +
      'html::-webkit-scrollbar-track-piece{background-color: transparent;}' +
      'html::-webkit-scrollbar-thumb{border-radius: 4px; ' +
      'background-color: #5ac4d6;}' +
      '</style>'
    $doc.append(style)

    frame.open()
    frame.write($doc.html())
    frame.close()
    embedDocOrigin.remove()
  },
  initLoginEmailValidation() {
    const $loginForm = $('#username_login')

    if ($loginForm.length) {
      const $emailInput = $('input[type="email"]')
      const $submitBtn = $('[type="submit"]')
      let disabled = false

      if (!$emailInput.val()) {
        $submitBtn.attr('disabled', true)
      }

      $emailInput.on('input', () => {
        disabled = !$emailInput.val()

        if (disabled) {
          $submitBtn.attr('disabled', disabled)
        } else {
          $submitBtn.removeAttr('disabled')
        }
      })
    }
  },
}
